import { Container } from "@mui/material";
import { useContext } from "react";
import { ContentWrapper } from "../components/layout/ContentWrapper";
import ReadingBar from "../components/utils/ReadingBar";
import RenderContent from "../components/utils/RenderContent";
import { ContentfulContext } from "../context/ContentfulContext";
import { Legal } from "../models/schema";

const LegalInformationPage = () => {
  const { content } = useContext(ContentfulContext);
  const legal = content?.legal as Legal;
  const { legalInfoLabel, legalInfoContent } = legal;

  return (
    <>
      <ReadingBar />
      <ContentWrapper title={legalInfoLabel as string}>
        <Container>
          <RenderContent
            content={legalInfoContent?.json}
            sx={{
              "& > h1,h2,h3,h4,h5,h6": {
                textAlign: "start"
              },
              "& > :not(template) ~ :not(template)": {
                mt: 5
              }
            }}
          />
        </Container>
      </ContentWrapper>
    </>
  );
};

export default LegalInformationPage;
